// src/scripts/contact/internal/domReady.js

import { isBrowser, DOM_READY_STATES } from './constants.js';
import { debugHelpers } from './debugHelpers.js';

export function waitForDOMReady() {
  if (!isBrowser) return Promise.resolve();
  if (document.readyState === DOM_READY_STATES.LOADING) {
    debugHelpers.log('Waiting for DOMContentLoaded');
    return new Promise(r => document.addEventListener('DOMContentLoaded', r, { once: true }));
  }
  return Promise.resolve();
}